import styles from "./style.module.css";
import ServiceOfferings from "../ServiceOfferings";
import LocatorServices from "../ServiceOfferings/LocatorServices";
import CbnFooter from "../CbnFooter";
import AltBankLogo from "../AltbankLogo";
import useClearLocalStorage from "../../customHooks/useClearLocalStorage";

export default function Slider() {
  useClearLocalStorage();
  return (
    <div>
      <ul className={styles.slideshow}>
        <li>
          <span>Image 01</span>
        </li>
        <li>
          <span>Image 02</span>
        </li>
        <li>
          <span>Image 03</span>
        </li>
        <li>
          <span>Image 04</span>
        </li>
        <li>
          <span>Image 05</span>
        </li>
        <li>
          <span>Image 06</span>
        </li>
      </ul>
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <AltBankLogo className={styles.logo} />
        </div>
        <div className={styles.flexContainer}>
          <div className={styles.textHolder}>
            <p>Easy account opening</p>
            {/* eslint-disable */}
            <h1></h1>
          </div>
          <div>
            <ServiceOfferings />
            <div className={styles.locatorServices}>
              <LocatorServices />
              <div className={styles.footerContainer}>
                <CbnFooter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
